module.exports = __webpack_public_path__ + "static/media/NICE_Step1a_Image5.36917e20.jpg";